import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";

import CorporateBusiness from "./pages/home/CorporateBusiness";
import Page404 from "./pages/others/Page404";
import { trackPageView } from "./helpers/analytics";

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router basename={"/"}>
      <Analytics />
      <Switch>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={CorporateBusiness} />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/404-page`}
          component={Page404}
        />
        <Route component={Page404} />
      </Switch>
    </Router>
  );
}

export default App;
